import { render, staticRenderFns } from "./WardImportRequestDetail.vue?vue&type=template&id=c4fcd732&"
import script from "./WardImportRequestDetail.vue?vue&type=script&lang=js&"
export * from "./WardImportRequestDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports